import ClapLogo from "assets/images/logo-small.png";
import Typography from "components/elements/Typography";
import { PencilIcon, XMarkIcon, CheckIcon } from "@heroicons/react/20/solid";
import classes from "./classes.module.scss";
import { useCallback, Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import I18n from "components/materials/I18n";
import { useProjectTitle } from "components/pages/ProfessionalSpace/contexts/ProjectTitle";
import Form from "components/materials/Form";
import { container } from "tsyringe";
import ProjectService from "services/ProjectService";

const projectService = container.resolve(ProjectService);

type IProps = {
	isEditing: boolean;
	setIsEditing: Dispatch<SetStateAction<boolean>>;
};

export default function TitleContainer(props: IProps) {
	const { title, setTitle, project, fetchProject } = useProjectTitle();
	const { isEditing, setIsEditing } = props;

	const toggleEditing = useCallback(() => setIsEditing((prev) => !prev), [setIsEditing]);

	const onCancelEditTitle = useCallback(() => {
		toggleEditing();
	}, [toggleEditing]);

	const onSubmit = useCallback(
		(formData: Record<string, unknown>) => {
			const title = formData["title"] as string;
			setTitle(title);
			projectService.updateProjectTitle(project.id, title).then(fetchProject);
			toggleEditing();
		},
		[fetchProject, project.id, setTitle, toggleEditing],
	);

	return (
		<div
			className={classNames(classes["root"], {
				[classes["editing"]!]: isEditing,
			})}>
			<img src={ClapLogo} className={classes["logo"]} alt="Clap Logo" />

			<div className={classes["title-edit-container"]}>
				{!isEditing && (
					<div className={classes["title-container"]}>
						<Typography type="h4" weight="bold">
							{I18n.asset.pages.professional_space.layout.project_title}: {title}
						</Typography>

						<button className={classes["edit-button"]} onClick={toggleEditing}>
							<PencilIcon className={classes["icon"]} />
						</button>
					</div>
				)}

				{isEditing && (
					<Form onSubmit={onSubmit} className={classes["edit-container"]}>
						<input name="title" className={classes["input"]} />
						<div className={classes["buttons-container"]}>
							<button className={classNames(classes["edit-button"], classes["close-button"])} onClick={onCancelEditTitle}>
								<XMarkIcon className={classes["icon"]} />
							</button>
							<button className={classNames(classes["edit-button"], classes["accept-button"])} type="submit">
								<CheckIcon className={classes["icon"]} />
							</button>
						</div>
					</Form>
				)}
			</div>
		</div>
	);
}
